import { useEffect, useState } from 'react';
import capitalize from 'lodash/capitalize';
import { css, cx } from '@eti/styles';
import { useDarkMode } from '@eti/providers';
import { jsx as _jsx } from "react/jsx-runtime";
const linkStyles = css`
  display: block;
`;
const PartnerLogo = ({
  className,
  collection,
  href,
  id
}) => {
  const [Logo, setLogo] = useState(null);
  const {
    isDarkMode
  } = useDarkMode();
  useEffect(() => {
    let isMounted = true;
    const lowercasedId = id.toLowerCase();
    const resolvedId = isDarkMode ? `${lowercasedId}-dark` : lowercasedId;
    const load = async () => {
      try {
        const {
          ReactComponent
        } = await import(`@eti/assets/logos/${collection}/${resolvedId}.svg`);
        if (isMounted) {
          setLogo(() => ReactComponent);
        }
      } catch (err) {
        if (isDarkMode) {
          try {
            // fall back to light version if dark variant doesn't exist
            const {
              ReactComponent
            } = await import(`@eti/assets/logos/${collection}/${lowercasedId}.svg`);
            if (isMounted) {
              setLogo(() => ReactComponent);
            }
          } catch (fallbackErr) {
            console.warn(fallbackErr); // oxlint-disable-line no-console
          }
        } else {
          console.warn(err); // oxlint-disable-line no-console
        }
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [collection, id, isDarkMode]);
  if (!Logo) {
    return null;
  }
  const logo = /*#__PURE__*/_jsx(Logo, {
    className: cx('etiPartnerLogo', className),
    "data-testid": `partner-logo-${id}`,
    role: "img",
    title: capitalize(id)
  });
  if (href) {
    return /*#__PURE__*/_jsx("a", {
      "aria-label": capitalize(id),
      className: cx('etiPartnerLogo__link', linkStyles),
      href: href,
      rel: "noreferrer",
      target: "_blank",
      children: logo
    });
  }
  return logo;
};
export default PartnerLogo;
//# sourceMappingURL=PartnerLogo.js.map